import { Input } from "../input/input";
import { SystemBase } from "./system.base";

export class InputSystem extends SystemBase {
    endOfFrame(): void {
        this.input.clearFrameInputs();
    }

    input: Input;

    constructor() {
        super();

        this.input = new Input();
    }

    initialize(root: HTMLElement) {
        this.input.initialize(root);
    }

    update(time: number, delta: number): void {
        
    }

}